import { render, staticRenderFns } from "./iconP6.vue?vue&type=template&id=2f26b66c&scoped=true&"
import script from "./iconP6.vue?vue&type=script&lang=js&"
export * from "./iconP6.vue?vue&type=script&lang=js&"
import style0 from "./iconP6.vue?vue&type=style&index=0&id=2f26b66c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f26b66c",
  null
  
)

export default component.exports